function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "down-arrow");

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 10.3,
    height: 6.8,
    viewBox: "0 0 10.3 6.8"
  }, props), _ref, React.createElement("polygon", {
    points: "5.17 6.8 0 0 10.3 0 5.17 6.8",
    style: {
      "fill": "#5481a3"
    }
  }));
};

export default __webpack_public_path__ + "static/media/down-arrow.3ab8454a.svg";
export { SvgComponent as ReactComponent };